module.exports = __webpack_public_path__ + "img/uncomplete_task_icon.87ad91a3.svg";